import { FC } from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { IFormSectionFilledCardProps } from './types';

import styles from './FormSectionFilledCard.module.scss';

export const FormSectionFilledCard: FC<IFormSectionFilledCardProps> = ({ children, title, className, ...props }) => (
  <Box {...props} className={clsx(styles.container, className)}>
    {title && (
      <Typography variant="body2" sx={{ marginBottom: 3 }}>
        {title}
      </Typography>
    )}
    {children}
  </Box>
);
